export const Icons = [
  'Anchor 2',
  'Valve',
  'GiRank2',
  'Teach',
  'People',
  'Board',
  'Sample',
  'FaLaptopCode',
  'Luggage Cart',
  'MdNotificationsActive',
  'Environmental',
  'FaClipboardList',
  'Certified',
  'InfoCircle',
  'Visual Alarm',
  'Peace',
  'Crane 3',
  'Sea',
  'Binoculars 3',
  'Ice 2',
  'Supervise',
];
export const FolderNames = [
  'All Ranks',
  'General',
  'Job Safety',
  'Office',
  'Ship',
  'Misc',
];

export const AllRanksIcons = [
  '2nd Engineer',
  '2nd Officer',
  '3rd Engineer',
  '3rd Officer',
  '4th Engineer',
  'Cadet',
  'Captain',
  'Catering Officer',
  'Chief Engineer',
  'Chief Officer',
  'Cook',
];

export const GeneralIcons = [
  'Accident',
  'Anchor',
  'Bad Feedback',
  'Basic Tick',
  'BatteryStatusFull',
  'Battery 1',
  'Battery 2',
  'Bell',
  'Binoculars',
  'Radiation Hazard',
  'BiologicalHazard',
  'Office Organisation',
  'Buoy',
  'Businessman',
  'Businessmen',
  'Captain Cap 1',
  'Captain Cap 2',
  'Cargo Ship 1',
  'Load Crane',
  'Caution',
  'Charity',
  'Chat Bubble',
  'Checked 1',
  'City',
  'Coal',
  'Cogwheel',
  'Cone',
  'Construction Crane',
  'Container',
  'Crane',
  'Cyber Security',
  'Deal',
  'Diesel',
  'Electricity',
  'Emergency Call 1',
  'Emergency Call 2',
  'Emergency',
  'Exit',
  'Faucet',
  'Feedback 1',
  'Feedback 2',
  'Fire Alarm',
  'Fire Exit',
  'Fire Extinguisher 1',
  'Fire Extinguisher 2',
  'Fire',
  'Fire Fighter 1',
  'Fire Fighter 2',
  'First Aid Kit',
  'Flash',
  'Flashlight',
  'Freight',
  'Fuel',
  'Gas Mask',
  'Gas Station',
  'Gas 1',
  'Gas 2',
  'Gasoline',
  'Global Services',
  'Graphic',
  'H2O',
  'Healthcare',
  'Helmet',
  'Hierarchical Structure',
  'Hierarchy 1',
  'Hierarchy 2',
  'High Voltage',
  'House',
  'Hydrant',
  'ID Card',
  'Idea',
  'Inflatable Boat',
  'Info Button 1',
  'Info Button 2',
  'Inspection',
  'Internet',
  'Leaf',
  'Leak',
  'Life Vest',
  'Life Boat',
  'Life Buoy',
  'Life Saver',
  'Lighthouse',
  'Location',
  'Locations',
  'Mechanical Gears',
  'Medal',
  'Megaphone',
  'Mooring Point',
  'Motor',
  'No Alcohol 1',
  'No Alcohol 2',
  'No Smoking',
  'No Vaccines',
  'No Waiting',
  'Office Building',
  'Radioactive Barrel',
  'Oil Drum',
  'Oil Pump',
  'Oil Tank 1',
  'Oil Tank 2',
  'Oxygen Tank',
  'Petroleum',
  'Pie Chart',
  'Pier 1',
  'Pier 2',
  'Plan',
  'Plant',
  'Poisonous',
  'Port',
  'Portal',
  'Presentation',
  'Prevention',
  'Printer',
  'Propeller',
  'Racing Flag',
  'Rescue Boat',
  'Rounded Plug',
  'Safety Goggles',
  'Sailor',
  'Satisfaction',
  'Sea 1',
  'Sea 2',
  'Search Engine',
  'Shield',
  'Ship',
  'Siren Light',
  'Siren',
  'Stand By',
  'Statistics',
  'Stumble',
  'Tank',
  'Tow Truck',
  'Tower Crane',
  'Radioactive',
  'Traffic Cone',
  'Traffic Data',
  'Training',
  'Trophy',
  'Propeller 2',
  'Goods',
  'User',
  'Warning',
  'Waves 1',
  'Waves 2',
  'Welder',
  'Welding Mask',
  'Compass2',
  'Worker',
  'World Grid',
  'Worldwide',
  'Wrench',
  'Bulletin',
  'Certificate',
  'ChainBreak',
  'CO2',
  'Collaborate',
  'Garbage',
  'Handbook',
  'Like',
  'Link',
  'Lock',
  'Lock Tag',
  'Manifold',
  'Manual',
  'Manuals',
  'Meeting 2',
  'NOx',
  'Order',
  'Permit',
  'Policy2',
  'Poster',
  'Read',
  'Recycle',
  'Signature',
  'Strategy',
];

export const JobSafetyIcons = [
  'Aerosol',
  'Apron',
  'Barrier',
  'Bell 2',
  'Binoculars 2',
  'Boots',
  'Boots 2',
  'Cctv',
  'Construction',
  'Coverall',
  'Coverall 2',
  'Crane 2',
  'Ear Protection',
  'Emergency 2',
  'Experiment',
  'Face Mask',
  'Face Protection',
  'Fire Alarm 2',
  'Fire Extinguisher 3',
  'First Aid Cross',
  'Flasher',
  'Flashlight 2',
  'Gas Mask 2',
  'Gauge',
  'Gloves',
  'Hand Washing',
  'Handrail',
  'Health Check',
  'Hydrant 2',
  'Life Preserver',
  'Multimeter',
  'Padlock',
  'Protective',
  'Protective Gloves',
  'Pull',
  'Radiation',
  'Reflective Vest',
  'Respiratory',
  'Safety',
  'Safety 2',
  'Seat Belt',
  'Smoke Detector',
  'Stop',
  'Traffic Cone 2',
  'Warning Sign',
  'Water Hose',
  'Welding Mask 2',
  'Whistle',
  'Worker 2',
  'Tools',
  'Back Pain',
  'Boat 1',
  'EPIRB',
  'Life Boat2',
  'Life Raft',
  'Man Overboard',
  'Meter',
  'No Mobile',
  'Rescue Boat 2',
  'Silence',
  'Stop 2',
  'Stop 3',
  'Toxic',
  'Transponder',
];

export const OfficeIcons = [
  'Commercial',
  'Communications',
  'Enviromental 1',
  'Enviromental 2',
  'Finance',
  'Finance 2',
  'IT',
  'Meeting',
  'Meetings 1',
  'Personnel',
  'Record',
  'RiskManagement',
  'Security',
  'Technical',
  'Mission',
];

export const ShipIcons = [
  'Appraisal',
  'Bunkering',
  'Captain 2',
  'Cargo Ballast',
  'Cargo Ship1',
  'Tanker',
  'Cyber Security2',
  'Deck Op',
  'Drills Train',
  'Engine Watch',
  'EngineOp',
  'Hierarchy ',
  'Ice',
  'Maintenance',
  'Manager',
  'Navigation',
  'Organization Structure',
  'Planning Per',
  'Purchasing',
  'Safety Management',
  'Safeworking',
  'Welfare',
  'Bulker2',
  'Chemical',
  'Clean',
  'Compass3',
  'Discharge',
  'Diver',
  'Drill',
  'Energy',
  'Flange-Gauge',
  'Flare',
  'Gauge2',
  'Helicopter',
  'Loading',
  'LPG',
  'Paint',
  'Plan2',
  'Pollution',
  'Pump',
  'Radar',
  'Radio',
  'Valve',
  'Valve2',
];
const AllIcons = [
  ...AllRanksIcons,
  ...GeneralIcons,
  ...JobSafetyIcons,
  ...OfficeIcons,
  ...ShipIcons,
  ...Icons,
];

export default AllIcons;
